import { alpha } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { tableRowClasses } from "@mui/material/TableRow";
export function table(theme) {
    return {
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    position: "relative",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "16px",
                    boxShadow: "0px 12px 24px -4px #919EAB1F,0px 0px 2px 0px #919EAB33",
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    // Selected row style
                    height: 56,
                    [`&.${tableRowClasses.selected}`]: {
                        backgroundColor: alpha(theme.palette.primary.dark, 0.04),
                        "&:hover": {
                            backgroundColor: alpha(theme.palette.primary.dark, 0.08),
                        },
                    },
                    "&:has(th)": {
                        height: 56,
                    },
                    // Transparent border for last row
                    "&:last-of-type": {
                        [`& .${tableCellClasses.root}`]: {
                            borderColor: "transparent",
                        },
                    },
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    "& tr:first-of-type th:first-of-type": {
                        borderTopLeftRadius: 24,
                        borderBottomLeftRadius: 8,
                    },
                    "& tr:first-of-type th:last-of-type": {
                        borderTopRightRadius: 24,
                        borderBottomRightRadius: 8,
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: `1px solid transparent`,
                    paddingTop: 8,
                    paddingBottom: 8,
                },
                head: {
                    fontSize: 14,
                    height: 56,
                    color: theme.palette.text.secondary,
                    fontWeight: theme.typography.fontWeightSemiBold,
                    backgroundColor: theme.palette.background.neutral,
                    borderBottom: "none",
                },
                stickyHeader: {
                    backgroundColor: theme.palette.background.neutral,
                    backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
                },
                paddingCheckbox: {
                    paddingLeft: theme.spacing(1),
                },
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    width: "100%",
                    borderRadius: "8px 8px 24px 24px",
                    background: theme.palette.background.neutral,
                },
                toolbar: {
                    height: 56,
                    minHeight: 56,
                },
                actions: {
                    marginRight: 8,
                },
                select: {
                    paddingLeft: 8,
                    "&:focus": {
                        borderRadius: theme.shape.borderRadius,
                    },
                },
                selectIcon: {
                    right: 4,
                    width: 16,
                    height: 16,
                    top: "calc(50% - 8px)",
                },
            },
        },
    };
}
